import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import { HasAccess } from '@permify/react-role';
import { Button, Card, Col, Form, Input, Row, Select } from 'antd';
import { getTemplateFighthingAll, postCreateTemplateFighthing } from 'api/templateFighthing';
import { getLotteryTypeAll } from 'api/lotteryType';
import { getTypeNumberAll } from 'api/typeNumber';
import { ErrorPage404 } from 'common/Error/error.common';
import { renderSkeletonTable } from 'common/Skeleton';
import { messageRequireIcon } from 'common/messageError/message.common';
import Color from 'constants/color';
import { getCookie } from 'helper/cookie';
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getControlRateLotteryTypeUserById } from 'api/controlRate';
const { Option } = Select;

const TemplateFighthingCreate = (props?: any) => {
   const{ id } = props
   const navigate = useNavigate();
   //  let id: any = null;
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const location = useLocation();
   const locationSplit = location?.pathname.split('/');
   const token = getCookie('access_tokenltl');
   const dataUser: any = getCookie('dataUser');
   const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
   const [form] = Form.useForm();
   const [isLoadingTypeNumberData, setIsLoadingTypeNumberData] = useState(true);
   const [dataTypeNumberData, setTypeNumberData] = useState<any>([]);

   // const [isLoadingPeriod, setIsLoadingPeriod] = useState(true);
   const [dataPeriod, setPeriod] = useState<any>([]);

   const [isLoadingTemplateFighthing, setIsLoadingTemplateFighthing] = useState(true);
   const [dataTemplateFighthingData, setTemplateFighthingData] = useState<any>([]);

   const [dataLotteryType, setDataLotteryType] = useState<any>([])
   const [isLoadingDataLotteryType, setIsLoadingDataLotteryType] = useState(false);
   const [lotteryType, setLotteryType] = useState<any>('');
   const [isLoadingControlRate, setIsLoadingControlRate] = useState(true);
   const [dataControlRateData, setControlRateData] = useState<any>([]);

   const inputRefsRate: any = useRef([]);
   const inputRefsAmount: any = useRef([]);

   const handleKeyPress = (e: any, index: number, isAmount: boolean) => {
      if (e.key === 'Enter') {
      e.preventDefault();
      if (isAmount) {
         const nextIndex = index + 1;
         if (inputRefsAmount.current[nextIndex])  {
            inputRefsAmount.current[nextIndex].focus();
         }
      } else {
         const nextIndex = index + 1;
         if (inputRefsRate.current[nextIndex]) {
         inputRefsRate.current[nextIndex].focus();
         }
      
      }
      }
   };



  const fetchTypeNumberList = useCallback(
   async (query? : any) => {
      setIsLoadingTypeNumberData(true);
      const params = {
       type_number_show: 'Y',
       order_by: 'id',
       order_type: 'ASC'
      };
      try {
         const responseData = await getTypeNumberAll({ token, params: params });
         if (responseData?.status === 200) {
            const { data } = responseData;
            setTypeNumberData(data?.data?.type_number);
            setIsLoadingTypeNumberData(false);
         } else {
            setTypeNumberData([]); 
            setIsLoadingTypeNumberData(false);
         }
      } catch (error) {
         setIsLoadingTypeNumberData(false);
      }
   },
   [token],
 );

   const fetchLotteryTypeMyData = useCallback(
      async (query: any) => {
         setIsLoadingDataLotteryType(true);
         const params = {
            ids: parseDataUser?.lottery_type
         };
         try {
            const responseData = await getLotteryTypeAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               // console.log(data)
               setDataLotteryType(data?.data?.lottery_type);
               setIsLoadingDataLotteryType(false);
            } else {
               setDataLotteryType('');
               setIsLoadingDataLotteryType(false);
            }
         } catch (error) {
            setIsLoadingDataLotteryType(false);
         }
      },
      [token, id],
   );

   useMemo(() => {
      if (token && parseDataUser) {
         fetchLotteryTypeMyData(parseDataUser?.lottery_type);
      }
   }, [token, id]);

   const fetchControlRateData = useCallback(
      async (id?: number) => {
         setIsLoadingControlRate(true)
         const params = {
            control_rate_lottery_type_id: Number(id),
            order_by: 'control_rate_lottery_type_id',
            order_type: 'ASC'
         };
         try {
            const responseData = await getControlRateLotteryTypeUserById({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setControlRateData([data?.data[0]])
               setIsLoadingControlRate(false);
            } else {
               setControlRateData([]);
               setIsLoadingControlRate(false);
            }
         } catch (error) {
            setIsLoadingControlRate(false);
         }
      },
      [token],
   );

   useMemo(() => {
      if (token && id) {
         fetchControlRateData(token && id)
      }
   }, [token && id]);

   const renderRoles = () => {
      if (isLoadingDataLotteryType === false) {
         return dataLotteryType?.map((value: any, index: number) => {
            if(id){
               // console.log(dataTemplateFighthingData)
               if(dataTemplateFighthingData[0]?.template_fighthing_lottery_type_id === value?.id){
                  return (
                     <Option value={value?.id} key={index}>{value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)</Option>
                  );
               }
            } else {
               return (
                  <Option value={value?.id} key={index}>{value?.lottery_type_name} | เปิดได้สูงสุด ({value?.lottery_type_max_count} งวด)</Option>
               );
            }
           
         });
      }
      return [];
   }

   const fetchTemplateFighthingData = useCallback(
      async (id?: number) => {
         // console.log(query)
         setIsLoadingTemplateFighthing(true);
         const params = {
            template_fighthing_lottery_type_id: Number(lotteryType ? lotteryType : id),
            order_by: 'template_fighthing_type_id',
            order_type: 'ASC'
         };
         try {
            const responseData = await getTemplateFighthingAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;

               setTemplateFighthingData(data?.data?.template_fighthing)
               const template_fighthingDataArray = data?.data?.template_fighthing;
               template_fighthingDataArray?.map((value: any, index: number) => {
                  const fieldId = `id_${index}`;
                  const fieldTypeId = `template_fighthing_type_id_${index}`;
                  const fieldRate = `template_fighthing_rate_${index}`;
                  const fieldAmount = `template_fighthing_amount_${index}`;
                  const fieldSlug = `template_fighthing_type_slug_${index}`;
                  const fieldTypeName = `template_fighthing_type_name_${index}`;
                  form.setFieldsValue({
                     [fieldId]: value?.id,
                     [fieldTypeId]: value?.template_fighthing_type_id,
                     [fieldRate]: value?.template_fighthing_rate,
                     [fieldAmount]: value?.template_fighthing_amount,
                     [fieldSlug]: value?.template_fighthing_type_slug,
                     [fieldTypeName]: value?.template_fighthing_type_name
                  });
               });
               // console.log(data)
               form.setFieldsValue({
                  'template_fighthing_lottery_type_id': data?.data?.template_fighthing[0]?.template_fighthing_lottery_type_id
               });
               setIsLoadingTemplateFighthing(false);
            } else {
               setTemplateFighthingData([]);
               setIsLoadingTemplateFighthing(false);
            }
         } catch (error) {
            setIsLoadingTemplateFighthing(false);
         }
      },
      [token],
   );

   useMemo(() => {
   if (token) {
      fetchTypeNumberList();
   }
   }, [token, fetchTypeNumberList]);

   useMemo(() => {
      if (token || id) {
         fetchTemplateFighthingData(id)
      }
      }, [token, fetchTemplateFighthingData, id]);

 const handleSubmit = async (values: any) => {
  const params: any = {
   template_fighthing_lottery_type_id: lotteryType ? lotteryType : id,
   template_fighthing: []
  };

//   console.log(values)
  for (let index = 0; index < dataTypeNumberData.length; index++) {
     const fieldId = `id_${index}`;
     const fieldTypeId = `template_fighthing_type_id_${index}`;
     const fieldRate = `template_fighthing_rate_${index}`;
     const fieldAmount = `template_fighthing_amount_${index}`;
     const fieldSlug = `template_fighthing_type_slug_${index}`;
     const fieldTypeName = `template_fighthing_type_name_${index}`;
     const getFieldId = await form.getFieldValue(fieldId);
     const getTypeId = await form.getFieldValue(fieldTypeId);
     const getTypeName = await form.getFieldValue(fieldTypeName);
     const getRate = await form.getFieldValue(fieldRate);
     const getAmount = await form.getFieldValue(fieldAmount);
     const getSlug = await form.getFieldValue(fieldSlug);
   //   console.log(getSlug)
     const dataArray : any = {
      id: await getFieldId,
      template_fighthing_type_id: await getTypeId,
      template_fighthing_rate: await getRate || null,
      template_fighthing_amount: await getAmount || null,
      template_fighthing_type_slug: await getSlug,
      template_fighthing_type_name: await getTypeName,
     }
   //   console.log(dataArray)
     params.template_fighthing.push(dataArray);
  }

  const createData = await postCreateTemplateFighthing({ token, params: params });
   if (createData.status === 200) {
      Swal.fire({
         icon: 'success',
         title: 'บันทึกข้อมูลสำเร็จ',
         showConfirmButton: false,
         timer: 5000,
         showCancelButton: true,
         cancelButtonText: 'ปิด'
      });
      navigate(`/backoffice/template_fighthing`);
      // await fetchTemplateFighthingData(id);
      // navigate(`/backoffice/period/edit/${createData?.data?.data?.id}`, { replace: true });
   } else {
      Swal.fire({
         icon: 'error',
         title: createData?.data?.message ? createData?.data?.message : 'บันทึกข้อมูลไม่สำเร็จ',
         showConfirmButton: false,
         timer: 5000,
      });
   }
};

   const renderDataTable = () => {
      if (isLoadingTypeNumberData) {
         return renderSkeletonTable(4, isLoadingTypeNumberData, <></>);
      }
   
      const isOwner = parseDataUser?.type === "Owner";
      // const columnCount = isOwner ? 3 : 2;
   
      return (
         <table className='table table-bordered'>
            <thead>
               <tr>
               <th><p style={{ textAlign: 'center', padding: '10px 0px 0px 0px' }}>ชนิดการแทง</p></th>
               <th><p style={{ textAlign: 'center', padding: '10px 0px 0px 0px' }}>สูงสุดต่อเลข</p></th>
               {isOwner && <th><p style={{ textAlign: 'center', padding: '10px 0px 0px 0px' }}>ยอดเงินลงทุน</p></th>}
               </tr>
            </thead>
            <tbody>
               {renderItem()}
            </tbody>
         </table>
      );
   };

 const renderItem = () => {
   const isOwner = parseDataUser?.type === "Owner";
 
   return dataTypeNumberData?.map((value: any, index: number) => (
     <tr key={index}>
       <td align='center' valign='middle'>
         <span style={{ fontWeight: 500 }}>{value?.type_number_name}</span>
         <Form.Item name={`id_${index}`} style={{ display: 'none' }}>
           <Input type="hidden" />
         </Form.Item>
         <Form.Item name={`template_fighthing_type_slug_${index}`} style={{ display: 'none' }} initialValue={value?.type_number_slug}>
           <Input type="hidden" />
         </Form.Item>
         <Form.Item name={`template_fighthing_type_name_${index}`} style={{ display: 'none' }} initialValue={value?.type_number_name}>
           <Input type="hidden" />
         </Form.Item>
         <Form.Item name={`template_fighthing_type_id_${index}`} style={{ display: 'none' }} initialValue={value?.id}>
           <Input type="hidden" />
         </Form.Item>
       </td>
       <td align='center' valign='middle'>
         <Form.Item
           name={`template_fighthing_rate_${index}`}
           initialValue={null}
           rules={[
             { max: 7, message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข') },
             { pattern: /^[0-9]+$/i, message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น') }
           ]}
         >
           <Input type="text" size='large' placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" onKeyUp={(e) => {
               onChangeValueRate(index)
               onCheckPriceRate(e, index, value?.type_number_slug)
            }} 
               onKeyPress={(e) => handleKeyPress(e, index, false)}
               ref={(el) => (inputRefsRate.current[index] = el)}
            />
         </Form.Item>
       </td>
       {isOwner && (
         <td align='center' valign='middle'>
           {value?.id !== 5 && value?.id !== 6 && value?.id !== 7 && (
             <Form.Item
               name={`template_fighthing_amount_${index}`}
               initialValue={null}
               rules={[
                 { max: 8, message: messageRequireIcon('จำนวนไม่เกิน 7 ตัวเลข') },
                 { pattern: /^[0-9]+$/i, message: messageRequireIcon('กรอกได้แค่ ตัวเลข เท่านั้น') }
               ]}
             >
               <Input type="text" size='large' placeholder="ใส่จำนวนเงินเป็นตัวเลข (0-9)" 
                  onKeyUp={() => onChangeValueAmount(index)} 
                  onKeyPress={(e) => handleKeyPress(e, index, true)}
                  ref={(el) => (inputRefsAmount.current[index] = el)}
               />
             </Form.Item>
           )}
         </td>
       )}
     </tr>
   ));
 };

 const onChangeValueRate = (index: number) => {
  const fieldAmount = `template_fighthing_amount_${index}`;
   form.setFieldsValue({
     [fieldAmount]: null,
  });
 }

 const onCheckPriceRate = (e: any, index: number, type: string) => {
   const value = parseInt(e.target.value);
   const dataBlock = dataControlRateData ? dataControlRateData[0] : null;
   const fieldRate = `template_fighthing_rate_${index}`;
   // กำหนดค่าสำหรับ type แต่ละประเภท
   const rateTypeMap: any = {
     three_top: 'control_rate_three_top_price',
     three_tod: 'control_rate_three_tod_price',
     two_top: 'control_rate_two_top_price',
     two_bottom: 'control_rate_two_bottom_price',
     three_bottom: 'control_rate_three_bottom_price',
     run_top: 'control_rate_run_top_price',
     run_bottom: 'control_rate_run_bottom_price',
   };
   // ตรวจสอบ type และเปรียบเทียบค่า
   const blockPrice = dataBlock ? parseInt(dataBlock[rateTypeMap[type]]) : null;
   if (blockPrice && value >= blockPrice) {
     form.setFieldsValue({
       [fieldRate]: String(blockPrice),
     });
   }
 };


 const onChangeValueAmount = (index: number) => {
  const fieldRate = `template_fighthing_rate_${index}`;
   form.setFieldsValue({
     [fieldRate]: null,
  });
 }

 return (
  <>
   <Helmet>
      <title>{'เทมเพลตตั้งสู้'}</title>
   </Helmet>
   <HasAccess
       roles={['Owner','Senior','Master','Agent']}
       permissions={['period-create']}
       renderAuthFailed={<ErrorPage404 />}
    >
      <Card 
         title={
            <div style={{ padding: '20px' }}>
               <h3 style={{ color: '#003a8c', margin: '0 0 20px 0', fontSize: '24px', borderBottom: '2px solid #003a8c', paddingBottom: '10px' }}>เทมเพลตตั้งสู้ <span style={{ color: Color.danger }}> ** หากไม่ต้องการรับไม่ต้องตั้งค่าอะไร ปล่อยให้เป็นช่องว่าง **</span></h3>
               <div style={{ display: 'flex', justifyContent: 'space-between' }}>
               </div>
            </div>
         }
      >
     <Form
         layout="vertical"
         autoComplete="off"
         onFinish={handleSubmit}
         form={form}
         initialValues={{
         }}
      >
      <Col span={isMobileView ? 24 :24}>
         <Form.Item
            name="template_fighthing_lottery_type_id"
            label="ประเภทหวย"
            rules={[
               {
                  required: true,
                  message: messageRequireIcon('กรุณากรอกข้อมูล ประเภทหวย'),
               },
            ]}
         >
            <Select placeholder="กรุณาเลือก ประเภทหวย"
               onChange={(e, option: any) => {
                  setLotteryType(option?.value)
               }}
               disabled={id}
            >
               {renderRoles()}
            </Select>
         </Form.Item>
      </Col>
       {renderDataTable()}
        <Row>
           <Col span={12}>
              <Link to="/backoffice/template_fighthing">
                 <Button type='text' htmlType="button" size='large' className="btn btn-md btn-secondary">
                    <ArrowLeftOutlined /> ย้อนกลับ
                 </Button>
              </Link>
           </Col>
           <Col span={12}>
              <Button type="primary" htmlType="submit" size='large' className="btn btn-md" style={{ float: 'right' }}>
                 <SaveOutlined /> {id ? 'อัปเดตข้อมูล' :`อัปเดตข้อมูล`}
              </Button>
           </Col>
        </Row>
      </Form>
     </Card>
    </HasAccess>
  </>
 )
}

export default TemplateFighthingCreate;